import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/_notFound.scss';

export default function NotFound() {
  return (
    <div className="notfound-page">
      <div className="notfound-container">
        <h1 className="notfound-code">404</h1>
        <p className="notfound-message">Cette page n'existe pas.</p>
        <p className="notfound-sub">La page que vous recherchez a peut-être été déplacée ou supprimée.</p>
        <Link to="/" className="notfound-link">
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
